module.exports = __webpack_public_path__ + "media/zomerhits.bdc712bb.mp4";